import React, { memo } from "react";
import { Col, Row, Menu, Layout } from "antd";
import Header from "../../components/Header/Header";
import SearchHangGiamThue from "../../components/Body/SearchHangGiamThue/SearchHangGiamThue";
import { Typography } from "antd";
import './SearchHangGiamThue.css'
const { Title } = Typography;
const SearchHangGiamThueScreen: React.FC = () => {
    return (
        <Layout className="search-hang-giam-thue-screen">
            <Header CustomHeader={() =>
            (
                <Row>
                    <Col md={12} style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    }}>
                        <Title style={{ padding: 0, margin: 0, textAlign: "center" }} level={5}>
                            Tra cứu mặt hàng giảm thuế theo Nghị định 44/2023/NĐ-CP
                        </Title>
                    </Col>
                    <Col md={12}>
                        <Menu className="search-hang-giam-thue-right-header" mode="horizontal" items={[
                            {
                                label: (<a href="https://kiemtrahoadon.vn/" target="_blank">Kiểm tra hóa đơn hợp lệ</a>),
                                danger: true,
                                title: "Kiểm tra hóa đơn hợp lệ",
                                key: "kiem-tra-hoa-don",
                            },
                            {
                                label: (<a href="https://minvoice.vn/phan-mem-quan-ly-hoa-don-dau-vao-dau-ra-msmi/" target="_blank">Quản lý hóa đơn mSMI</a>),
                                title: "Quản lý hóa dơn mSMI",
                                key: "quan-ly-hoa-don-mSMI"
                            }
                        ]}>
                        </Menu>
                    </Col>
                </Row>
            )}
            />
            <SearchHangGiamThue />
        </Layout>
    )
}
export default memo(SearchHangGiamThueScreen);